import React from "react";
import BuyStakesNavbar from "../navbar/BuyStakesNavbar";
import { FaChevronDown } from "react-icons/fa";

import {
  FaFacebook,
  FaLinkedin,
  FaYoutube,
  FaPhoneAlt,
  FaArrowAltCircleRight,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const Header = () => {
  return (
    <div id="header">
      <div
        className="pt-4"
        style={{
          background:
            'url("/assests/Homepageheader.png") no-repeat center center/cover',
        }}
      >
        <div className="d-flex justify-content-between px-md-5 mx-6">
          <div className="d-flex gap-4 ">
            <a href="https://www.facebook.com/kibisports" target="_blank">
              <FaFacebook color="white" size={22} />
            </a>
            <a
              href="https://in.linkedin.com/company/kibi-sports"
              target="_blank"
            >
              <FaLinkedin color="white" size={22} />
            </a>
            <a href="https://www.youtube.com/c/KIBISPORTS" target="_blank">
              <FaYoutube color="white" size={22} />
            </a>
          </div>
          <div className="text-white">
            <ul className="d-md-flex gap-3">
              <li className="d-flex gap-2">
                <FaPhoneAlt color="white" size={20} />
                <p>+91 1234567890</p>
              </li>
              <li className="d-flex gap-2">
                <MdEmail color="white" size={20} />
                <p>testing@gmail.com</p>
              </li>
            </ul>
          </div>
        </div>
        <BuyStakesNavbar />

        <div className="py-5">
          <h1 className="text-white headerText text-center">
            <span className="fw-bold">Pick Any Game Or Contest</span>
          </h1>
          <p className="mt-4 text-white normalText text-center">
            Built to develop the sports industry.
          </p>
          <div className="d-md-flex gap-2 justify-content-center text-center align-self-center">
            <div class="dropdown mb-1">
              <button
                class="btn  shadow-none"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  width: "10.4rem",
                  color: "#FFF",
                  border: "1px solid white",
                }}
              >
                Filter by sports <FaChevronDown className="my-1 ms-1" />
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a class="dropdown-item" href="#">
                    Cricket
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Football
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Something else here
                  </a>
                </li>
              </ul>
            </div>

            <div class="dropdown mb-1">
              <button
                class="btn shadow-none"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  width: "10.4rem",
                  color: "#FFF",
                  border: "1px solid white",
                }}
              >
                Filter by Stakes <FaChevronDown className="my-1" />
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a class="dropdown-item" href="#">
                    Action
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Another action
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Something else here
                  </a>
                </li>
              </ul>
            </div>
            <div class="dropdown mb-1">
              <button
                class="btn shadow-none"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  width: "10.4rem",
                  color: "#FFF",
                  border: "1px solid white",
                }}
              >
                Filter by Date <FaChevronDown className="my-1 ms-1" />
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a class="dropdown-item" href="#">
                    Action
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Another action
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Something else here
                  </a>
                </li>
              </ul>
            </div>
            <div class="dropdown">
              <button
                class="btn btn-light shadow-none me-1"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  width: "10rem",
                  color: "#000",
                }}
              >
                Apply Filter
              </button>
            </div>
            {/* <button className="arrowBtn px-3 my-1">
              <p className="pt-1">Apply Filter</p>
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
